<template lang="pug">
#admin_container.container-small
  h1#container_title 팝업레이어 관리
  .container_wr
    .local_ov01.local_ov
      span.btn_ov01
        span.ov_txt PC
        span.ov_num {{pc}}건
      span.btn_ov01
        span.ov_txt Mobile
        span.ov_num {{mobile}}건
    .btn_fixed_top
      a.btn.btn_01(v-if="limitPopup" @click='$_goTo({name: "popup-write-admin"})') 팝업 추가
      p.limit_info(v-else) *팝업은 pc, mobile 각 3개씩 추가할 수 있습니다.
    .tbl_head00.tbl_wrap
      table
        thead
          tr
            th(scope="col") 번호
            th(scope="col") 제목
            th(scope="col") 접속기기
            th(scope="col") 시작일시
            th(scope="col") 종료일시
            th(scope="col") 관리
        tbody
          tr(v-for="i in res" :key="i.idx")
            td {{i.IDX}}
            td {{i.TITLE}}
            td {{i.DEVICE}}
            td {{i.START_TIME}}
            td {{i.END_TIME}}
            td.popup_set
              button.popup_edit(@click='$_goTo({name: "popup-edit-admin", params: {idx: i.IDX}})') 수정
              button.popup_del(@click='removePopup(i.IDX)') 삭제
          tr(v-if="res.length == 0")
            td.empty_table(colspan='7') 자료가 한 건도 없습니다.
    
    div(style="clear: both;")
    hr(style="margin: 30px 0;")
    
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  components: {},
  data() {
    return {
      args: {
        nation: 'kr',
      },
      res: [],
      pc: 0,
      mobile: 0,
    };
  },
  computed: {
    ...mapGetters(['popup']),
    limitPopup() {
      const maxPC = 3;
      const maxMOBILE = 3;
      this.pc = 0;
      this.mobile = 0;
      this.res.forEach((e, i) => {
        if (e.DEVICE == 'both') {
          this.pc++;
          this.mobile++;
        } else if (e.DEVICE == 'pc') {
          this.pc++;
        } else if (e.DEVICE == 'mobile') {
          this.mobile++;
        }
      });
      if (maxPC <= this.pc && maxMOBILE <= this.mobile) {
        return false;
      }
      return true;
    },
  },
  methods: {
    removePopup(idx) {
      this.$_axios('PUT', 'admin/popup/del', { idx: idx }).then(() => {
        alert('삭제되었습니다.');
        this.getPopup();
      });
    },
    getPopup() {
      this.$_admin_get('admin/popup/list').then(res => {
        this.res = res.data.res;
      });
    },
  },
  mounted() {
    this.getPopup();
  },
  created() {},
};
</script>

<style scoped>
@import '../../../assets/css/admin.css';
.limit_info {
  line-height: 30px;
  font-weight: bold;
}
.popup_set button {
  background-color: #ececec;
  border: 0;
  border-radius: 5px;
  width: 45px;
  height: 28px;
  color: black;
}
.popup_set button:hover {
  background-color: #e0e0e0;
}
td.popup_set {
  width: 130px;
}
.popup_edit {
  margin-right: 10px;
}
.btn_ov01 {
  margin-right: 10px;
}
</style>
